import { useState } from 'react'
import ItemTabs from 'components/ItemTabs'
import { GOAL_PERCENTAGES } from 'services/CashFlow'
import { Container, HintText } from 'pages/Financial/Dre/styles'
import GoalsByQuantity from './GoalsByQuantity'
import GoalsByValue from './GoalsByValue'

const VIEW_TABS = [
  { label: 'Metas N°', value: 'quantity' },
  { label: 'Metas $', value: 'value' }
]

const PERCENTAGE_TABS = GOAL_PERCENTAGES.map(percentage => ({
  label: `${percentage}%`, value: String(percentage)
}))

export default function Goals({ year, month }) {
  const [view, setView] = useState('quantity')
  const [percentage, setPercentage] = useState('100')
  // Categoria escolhida nas abas "Metas N°" e "Metas $"; null é a primeira categoria.
  const [filter, setFilter] = useState({ categoryId: null })

  return (
    <Container style={{
      gap: 0,
      paddingLeft: 15,
      paddingRight: 15,
      paddingBlock: 0
    }}>
      <ItemTabs
        tabs={VIEW_TABS}
        selectedTab={view}
        tabWidth={190}
        onTabChange={setView}
        containerStyle={{paddingTop: 0, paddingBottom: 15}}
      />
      <HintText>Quanto da receita máxima projetada você quer enxergar como meta:</HintText>
      <ItemTabs
        tabs={PERCENTAGE_TABS}
        selectedTab={percentage}
        tabWidth={90}
        onTabChange={setPercentage}
        containerStyle={{paddingBottom: 20}}
      />
      {view === 'quantity' && (
        <GoalsByQuantity
          year={year}
          month={month}
          percentage={Number(percentage)}
          filter={filter}
          onFilterChange={setFilter}
        />
      )}
      {view === 'value' && (
        <GoalsByValue
          year={year}
          month={month}
          percentage={Number(percentage)}
          filter={filter}
          onFilterChange={setFilter}
        />
      )}
    </Container>
  )
}
